import { render, staticRenderFns } from "./BarChartPassengersThreeMonths.vue?vue&type=template&id=e54a34aa&scoped=true&"
import script from "./BarChartPassengersThreeMonths.vue?vue&type=script&lang=js&"
export * from "./BarChartPassengersThreeMonths.vue?vue&type=script&lang=js&"
import style0 from "./BarChartPassengersThreeMonths.vue?vue&type=style&index=0&id=e54a34aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54a34aa",
  null
  
)

export default component.exports